import {
  createBackup,
  getUserDetails,
  listSnapshots,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/app/office/recovery/one-drive/oneDrive";
import files from './data-set/file'
import exports from "@/store/app/office/recovery/one-drive/exports";
import restores from "@/store/app/office/recovery/one-drive/restores";
import backups from "@/store/app/office/recovery/one-drive/backups";
import user from "@/store/app/office/recovery/one-drive/user";

const defaultState = () => ({
  userMap: {},
});

export default {
  namespaced: true,
  actions: {
    getUserDetails({commit}, userId) {
      return getUserDetails(userId)
        .then(user => {
          commit('setUser', user);
          return user;
        })
    },
    createBackup({commit}, userId) {
      return createBackup(userId);
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot(data);
    },
    listSnapshots({commit}, {userId, date, dateTo}) {
      return listSnapshots({userId, date, dateTo})
    },
    restoreSnapshot({commit}, data) {
      return restoreSnapshot(data);
    }
  },

  mutations: {
    setUser(state, user) {
      state.userMap = {
        ...state.userMap,
        [user.userId]: user
      };
    },
  },

  getters: {
    getUserById: (state) => (id) => {
      return state.userMap[id];
    },
  },

  state: defaultState(),

  modules: {
    files,
    exports,
    restores,
    backups,
    user
  }
}
